export{default}from'./capitalize';